module.exports = __webpack_public_path__ + "static/media/705aeb2baf7d21ae4fae34c271697be9.39a19d96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maps/705aeb2baf7d21ae4fae34c271697be9.jpg
// module id = 304
// module chunks = 0